import React from 'react';
import { AcceptDeclineForm } from '../../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { SonForm } from '../../../../_lib/Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { MemberType } from '../../../../types/api/MemberType';
import { useRefreshView } from '../../../../_lib/ViewFetcher';
import { useModalContext } from '../../../organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../../hooks/useDelayed';

type MemberDeleteFormProps = {
  form: SonForm<any>;
  member: MemberType;
};

export function MemberDeleteForm({ form, member }: MemberDeleteFormProps) {
  const { t } = useSonTranslation('MemberRow');
  const { refreshView } = useRefreshView();
  const { closeModal } = useModalContext();
  const delayedCloseAndRefresh = useDelayed(() => {
    refreshView();
    closeModal();
  });

  return (
    <AcceptDeclineForm
      messageSuccess={t('status.remove.success')}
      messageSending={t('status.remove.sending')}
      messageFail={t('status.remove.fail')}
      headline={t('status.remove.headline', { name: member.profileName })}
      form={form}
      onSuccess={delayedCloseAndRefresh}
    />
  );
}
